import React from 'react'
import dayjs from 'dayjs'
import Icon from '@mdi/react'
import { mdiCalendar, mdiReply } from '@mdi/js'
import Image from 'components/common/Image'

const CommentItem = React.memo((props) => {
  const { meId, data, allowReply, isReplying, onReply, onCancelReply } = props
  const showTargetTitle = data.resume || data.article
  const nickname = data.user.nickname || data.user.username
  const isSelfResume = data.resume?.user.id === meId

  let targetText

  if (showTargetTitle) {
    if (data.article) {
      targetText = (
        <span>
          <b className="text-gray-600">{nickname} </b>回复了你在文章
          <a href={`/articles/${data.article.id}`} target="_blank" className="font-medium text-primary">
            《{data.article.title}》
          </a>
          中的评论
        </span>
      )
    } else {
      const targetLink = isSelfResume ? `/me/resumes/${data.resume?.id}` : `/resumes/${data.resume?.uuid}`

      if (data.replyTo?.user.id === meId) {
        targetText = (
          <span>
            <b className="text-gray-600">{nickname} </b>回复了你在简历
            <a href={targetLink} target="_blank" className="font-medium text-primary">
              《{data.resume.title}》
            </a>
            中的评论
          </span>
        )
      } else {
        targetText = (
          <span>
            <b className="text-gray-600">{nickname} </b>评论了你的简历
            <a href={targetLink} target="_blank" className="font-medium text-primary">
              《{data.resume.title}》
            </a>
          </span>
        )
      }
    }
  } else {
    targetText = <b className="text-gray-600">{nickname}</b>
  }

  return (
    <li key={data.id} className="mb-4 flex items-start border-b border-dashed border-gray-200 bg-white px-1 pb-4 lg:mb-8 lg:pb-8">
      <Image className="h-8 w-8 rounded-full lg:h-12 lg:w-12" src={data.user.avatar} type="avatar" crop="96x96" />
      <div className="ml-3 flex flex-1 flex-col">
        <div className="mt-1 flex items-center justify-between text-tiny text-gray-500 lg:text-sm">{targetText}</div>
        <div className={`-ml-11 mt-4 rounded bg-gray-100/80 p-4 text-tiny leading-6 text-gray-500 lg:ml-0 ${isReplying ? 'shadow-line shadow-primary' : ''}`}>
          {data.replyTo && (
            <blockquote className="mb-2 rounded bg-white p-6 text-xs">
              <b>{data.replyTo.user.nickname || data.replyTo.user.username}</b>：{data.replyTo.content}
            </blockquote>
          )}
          <p className="text-gray-500">{data.content}</p>
        </div>
        <div className="-ml-11 mt-4 flex items-center justify-between text-tiny text-gray-400 lg:ml-0">
          <div className="flex items-center">
            <Icon path={mdiCalendar} size={0.7} className="mt-[2px]" />
            <span className="ml-1">{dayjs(data.updatedAt || data.createdAt).fromNow()}</span>
          </div>
          {allowReply &&
            (isReplying ? (
              <button className="flex items-center" onClick={onCancelReply}>
                <Icon path={mdiReply} size={0.7} className="mt-[2px]" />
                <span className="ml-1">取消回复</span>
              </button>
            ) : (
              <button className="flex items-center" data-username={nickname} data-id={data.id} onClick={onReply}>
                <Icon path={mdiReply} size={0.7} />
                <span className="ml-1">回复</span>
              </button>
            ))}
        </div>
      </div>
    </li>
  )
})

export default CommentItem
